import OfferType from '../../../interfaces/Offer.type'

const createMetaTitle = (offer: OfferType): string => {
  return `${offer.title} - whiskymarket.com`
}

export default createMetaTitle
